import classNames from 'classnames';

export const buttonClassName = classNames(
  'disabled:bg-transparent',
  'disabled:text-gray-400',
  'disabled:border-gray-400',
  'disabled:shadow-none',
  'hover:bg-gray-100',
  'hover:border-gray-300',
  'bg-white',
  'text-gray-700',
  'font-medium',
  'py-2',
  'px-12',
  'ml-3',
  'border-2',
  'border-gray-300',
  'rounded',
  'text-base',
);

export const ButtonTestID = 'CancelSessionButtonTestID';
export const CircularProgressTestID = 'CancelSessionCircularProgressTestID';
